/*
Centralize place that converts $stateParams into PurchaseOrder queries.
Designed to work with the "purchaseOrderFilters" directive
*/
import moment from 'moment-timezone';

export default __filename;
angular
  .module(__filename, [require('goodeggs-purchase-orders-sdk/purchase_order/angular_resource')])

  .factory(
    'purchaseOrderFilterService',
    ngInject((PurchaseOrder, $stateParams, $q, ngToast, rollbar) => ({
      /*
    @param {String} vendorId - include vendorId in query
    @returns {Array} - result of PurchaseOrder query
    */
      query({vendorId} = {}) {
        let poNumber;
        if (!isNaN($stateParams.searchBy)) {
          poNumber = $stateParams.searchBy;
        }
        const filterAdded = Boolean(
          vendorId ||
            $stateParams.status ||
            $stateParams.searchBy ||
            $stateParams.dropoffDay ||
            $stateParams.dropoffWindow ||
            $stateParams.confirmByDay ||
            $stateParams.statusDate,
        );

        const purchaseOrders =
          // if searching by a number, assume that it is a PO number (ignoring the use case of vendors which have all numbers in slug like 4505)
          (() => {
            if (poNumber != null) {
              return PurchaseOrder.query({
                poNumber,
                foodhubSlug: $stateParams.foodhubSlug,
              });

              // if any filter (other than foodhubSlug) added, look for purchaseOrders with those parameters
            } else if (filterAdded) {
              const queryParams = {
                vendorId,
                foodhubSlug: $stateParams.foodhubSlug,
                status: $stateParams.status,
                searchByItem: $stateParams.searchBy,
                dropoffDay: $stateParams.dropoffDay,
                dropoffWindow: $stateParams.dropoffWindow,
                confirmByDay: $stateParams.confirmByDay,
              };

              if ($stateParams.statusDate != null) {
                const param = (() => {
                  switch ($stateParams.status) {
                    case 'new':
                      return 'createdOn';
                    case 'submitted':
                      return 'submittedOn';
                    case 'confirmed':
                      return 'confirmedOn';
                    default:
                      return undefined;
                  }
                })();
                if (param != null) {
                  queryParams[param] = moment($stateParams.statusDate).toDate();
                }
              }

              return PurchaseOrder.query(queryParams);
            }
            // otherwise, if not filtering in any way, do not query for purchase orders
            const result = [];
            result.$promise = $q.when();
            return result;
          })();

        purchaseOrders.$promise.catch((err) => {
          ngToast.danger('Failed to load purchase orders. Please try again later.');
          return rollbar.error({err}, 'Failed to load purchase orders');
        });

        return purchaseOrders;
      },
    })),
  );
